import React from "react";
import "./BusDot.scss";

type BusDotProps = {
    readonly color: string;
    readonly small?: boolean;
};

const BusDot: React.FC<BusDotProps> = (props) => {
    const { color, small } = props;

    return (
        <div
            className={`BusDot-icon ${small ? "BusDot-small" : ""}`}
            style={{ borderColor: color }}
        />
    );
};

export default BusDot;
